import { PartnerDTO } from 'dtos/PartnerDTO'
import instanceOfPostpaidPartner from '../intanceOfPospaidPartner'

export class PartnerController {
  static getUsername = async (): Promise<Array<PartnerDTO>> => {
    let response: any
    try {
      response = await instanceOfPostpaidPartner.get('v2/partners/usernames')
    } catch (error) {
      console.log(error)
    }
    return response.data.data.entities.map((it: PartnerDTO) => new PartnerDTO(it.id, it.username))
  }
}
